export default {
    pl: {
        default: 'zł',
        iso4217: 'PLN',
    },
};
